import _ from 'lodash'
import React from 'react'
import { Button, Icon } from 'semantic-ui-react'
import { uniqueKey } from '../../../common/keys'
import { appIconTypes } from '../../../enums/appIconTypes'
import { iconColorTypes } from '../../../enums/settingsIconTypes'
import { settingsActionTypes } from '../../enums/itemActionTypes'

export const FetchButton = (props) => {

  const { handleReset, previewClicked, previewReady, actionName, handlePreview, handleItemHelp } = props

  const _caption = _.startCase(actionName)

  const cn = 'cbc-container n'
  const bg = 'black'

  const bgLoading = () => <Button.Group icon key={uniqueKey('bl')} size='small' className={cn + ' pre'}>
    <Button key={uniqueKey('bl', 1)} color={bg} onClick={() => handlePreview(actionName)}><Icon name='cog' /></Button>
    <Button key={uniqueKey('bl', 2)} color={bg} onClick={() => handlePreview(actionName)}>{_caption} </Button>
    {previewClicked && <Button key={uniqueKey('bl', 3)} color={iconColorTypes.fetching}><Icon name='cog' loading /></Button>}
  </Button.Group>

  const bgArrowRight = () =>
    <Button.Group icon key={uniqueKey('br')} size='small' className={cn + ' non-pre'}>
      <Button key={uniqueKey('br', 1)} color={bg} onClick={() => handlePreview(actionName)}><Icon name='cog' /></Button>
      <Button key={uniqueKey('br', 2)} color={bg} onClick={() => handlePreview(actionName)}>{_caption} </Button>
      <Button key={uniqueKey('br', 3)} color={bg}><Icon name={appIconTypes.arrowRight} /></Button>
    </Button.Group>

  const bgPreview = () => previewClicked ? bgLoading() : bgArrowRight()

  const bgHelp = () => <Button.Group icon key={uniqueKey('bh')} size='small' className={cn + ' help'}>
    <Button key={uniqueKey('bh', 1)} color={bg} onClick={() => handleReset()}><Icon name={appIconTypes.arrowLeft} /></Button>
    <Button key={uniqueKey('bh', 2)} color={bg} onClick={() => handleReset()}>{_caption} </Button>
    <Button key={uniqueKey('bh', 3)} color={bg} onClick={() => handleItemHelp()}><Icon circular inverted name='help' color={iconColorTypes.help} /></Button>
  </Button.Group>

  switch (actionName) {

    case settingsActionTypes.backupSettings:
    case settingsActionTypes.baseForms:
    case settingsActionTypes.baseSettings:
    case settingsActionTypes.copyEvent:
    case settingsActionTypes.createClient:
    case settingsActionTypes.createEvent:
    case settingsActionTypes.currentSettings:
    case settingsActionTypes.deleteClient:
    case settingsActionTypes.deleteEvent:
    case settingsActionTypes.recreateEvent:
    case settingsActionTypes.restoreSettingsFromBackup:
    case settingsActionTypes.restoreSettingsFromPaste:
    case settingsActionTypes.transferDataToProduction:
    case settingsActionTypes.transferEventToProduction:
    case settingsActionTypes.transferSettingsToProduction:
    case settingsActionTypes.updateEventStatus:
      return previewClicked ? bgHelp() : bgArrowRight()

    case settingsActionTypes.duplicateGoogleSheets:
    case settingsActionTypes.convertSettingsToSeparate:
    case settingsActionTypes.fixSettings:
    case settingsActionTypes.pushClientToProduction:
    case settingsActionTypes.pushEventToProduction:
    case settingsActionTypes.restoreSettingsFromRegistration:
    case settingsActionTypes.updateDataFromGoogleData:
    case settingsActionTypes.updateDataFromGoogleSheets:
    case settingsActionTypes.updateSettingsFromGoogleSheets:
      if (previewClicked) {
        return previewReady ? bgHelp() : bgLoading()
      } else {
        return bgArrowRight()
      }

    default:
    // nothing
  }

  return previewReady ? bgHelp() : bgPreview()
}